import { OnInit, OnDestroy, Directive, SkipSelf, Optional, Attribute, Injector, Input } from '@angular/core'
import { NgForm, FormArray, FormGroup, AbstractControl } from '@angular/forms'

const formsArrayName = 'childForms'

@Directive({
  selector: '[appNestableForm]'
})
export class NestableFormDirective implements OnInit, OnDestroy {
  @Input()
  private formGroup: FormGroup
  private currentForm: FormGroup
  private get formsArray() {
    return this.currentForm.get(formsArrayName) as FormArray
  }
  constructor(
    @SkipSelf()
    @Optional()
    private parentForm: NestableFormDirective,
    private injector: Injector,
    @Attribute('rootForm')
    private isRoot
  ) { }
  ngOnInit() {
    if (!this.currentForm) {
      setTimeout(() => {
        this.currentForm = this.formGroup || this.injector.get(NgForm).control
        this.currentForm.addControl(formsArrayName, new FormArray([]))
        if (this.parentForm && !this.isRoot) {
          this.parentForm.formsArray.push(this.currentForm)
        }
      })
    }
  }
  ngOnDestroy() {
    if (this.parentForm) {
      setTimeout(() => {
        const parentForms = this.parentForm.formsArray
        parentForms.removeAt(parentForms.controls.indexOf(this.currentForm))
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared-services/nesteable-form.directive.ts